export var DEFAULT_MAX_INVITE_TIMES = 20;
export var ItemStatusEnum = /*#__PURE__*/function (ItemStatusEnum) {
  ItemStatusEnum[ItemStatusEnum["NORMAL"] = 1] = "NORMAL";
  ItemStatusEnum[ItemStatusEnum["CHECKING_CONFLICT"] = 2] = "CHECKING_CONFLICT";
  ItemStatusEnum[ItemStatusEnum["DELETED"] = 3] = "DELETED";
  return ItemStatusEnum;
}({});
export var CREATOR_SEARCH_INPUT_WIDTH = 500;
export var CREATOR_SEARCH_INPUT_SHORT_WIDTH = 400;
export var TableTypeEnum = /*#__PURE__*/function (TableTypeEnum) {
  TableTypeEnum[TableTypeEnum["SELECT_CREATORS_FORM_ITEM"] = 0] = "SELECT_CREATORS_FORM_ITEM";
  TableTypeEnum[TableTypeEnum["SELECT_CREATORS_WITHOUT_CREATOR_CONNECT"] = 1] = "SELECT_CREATORS_WITHOUT_CREATOR_CONNECT";
  TableTypeEnum[TableTypeEnum["SELECT_PRODUCTS_FORM_ITEM"] = 2] = "SELECT_PRODUCTS_FORM_ITEM";
  TableTypeEnum[TableTypeEnum["PRODUCT_SELECTION_DRAWER"] = 3] = "PRODUCT_SELECTION_DRAWER";
  TableTypeEnum[TableTypeEnum["PRODUCT_SELECTION_DRAWER_SEARCHING"] = 4] = "PRODUCT_SELECTION_DRAWER_SEARCHING";
  TableTypeEnum[TableTypeEnum["SELECT_CREATORS_FOR_FLAT_FEE"] = 5] = "SELECT_CREATORS_FOR_FLAT_FEE";
  TableTypeEnum[TableTypeEnum["FLAT_FEE_SELECT_PRODUCT"] = 6] = "FLAT_FEE_SELECT_PRODUCT";
  return TableTypeEnum;
}({});